import { render, staticRenderFns } from "./AgendaCalendar.vue?vue&type=template&id=e38de82e"
import script from "./AgendaCalendar.vue?vue&type=script&lang=js"
export * from "./AgendaCalendar.vue?vue&type=script&lang=js"
import style0 from "./AgendaCalendar.vue?vue&type=style&index=0&id=e38de82e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports